<template>
    <div :class="['layout', group]">
        <div v-for="(item, i) in items" :key="i">
            <div class="item single">
                <p class="name">{{ Name(item) }}</p>
                <div class="bar">
                    <div class="bar-value"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PaletteSummaryList",
    props: {
        group: String,
        items: Array
    },
    methods: {
        Name: function(item) {
            switch(this.group) {
                case "usage":
                    return item.Type;
                case "tools":
                    return item.Tool;
                case "languages":
                    return item.Language;
            }
        }
    }
};
</script>